import z from 'zod';
const reasonValues = ['corrupt-pdf', 'encrypted-pdf', 'no-pages', 'corrupt-image'];
export const documentFailedWebhookSchema = z.looseObject({
    type: z.literal('document-failed'),
    projectId: z.string(),
    documentId: z.string(),
    correlationId: z.string().optional(),
    errorCode: z.string(),
    errorMessage: z.string(),
    reason: z.enum(reasonValues).optional(),
});
//# sourceMappingURL=document-failed.webhook.js.map